import React, { useState } from "react";
import { cn } from "@/lib/utils";

/** Round portrait with the author's initial when there is no (working) photo. */
export const AuthorAvatar = ({ src, name = "", className }) => {
  const [failed, setFailed] = useState(false);
  return (
    <div className={cn("relative aspect-square overflow-hidden rounded-full bg-secondary text-secondary-foreground [container-type:inline-size]", className)}>
      {src && !failed ? (
        <img src={src} alt={name} loading="lazy" decoding="async" width="160" height="160"
          onError={() => setFailed(true)} className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <span role="img" aria-label={name} className="absolute inset-0 flex items-center justify-center font-display text-[42cqw]">
          {[...name.trim()][0] || "?"}
        </span>
      )}
    </div>
  );
};
